<template>
  <div style="height:100%">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import getAllGame from '@/mixins/get-all-game.js'
export default {
  mixins: [getAllGame],
  computed: {
    ...mapGetters(['initialized']),
  },
  created () {
    this.initvuex()
    this.getcompanyname()
  },
  methods: {
    ...mapActions(['initstorage', 'setlogin']),
    initvuex () {
      if (!this.initialized) this.initstorage()
    },
    async getcompanyname () {
      try {
        const res = await this.$axios.companyname()
        document.title = res[0].companyname
      } catch (error) {
        console.error(error)
      }

    }
  }
}
</script>